import React from 'react'
import { Link } from 'react-router-dom'

const PageNotFound = () => {
    return (
        <>
            <div className="container">
                <div className='page-not-found' >
                    <h2 data-aos="fade-right" data-aos-duration="1500" data-aos-easing="linear">404</h2>
                    <h3 data-aos="fade-left" data-aos-duration="1500" data-aos-easing="linear">UH OH! You're lost.</h3>
                    <p data-aos="flip-left" data-aos-duration="1500" data-aos-easing="linear">
                        The page you are looking for does not exist. How you got here is a
                        mystery. But you can click the button below to go back to the
                        homepage.
                    </p>
                    <button className='custom_btn' data-aos="zoom-out-up" data-aos-duration="1500" data-aos-easing="linear">
                        <Link to="/">Go To Home</Link>
                    </button>
                </div>
            </div>
        </>
    )
}

export default PageNotFound